<template>
  <div class="title_bar">
    <el-menu :default-active="activeIndex" @select="handleSelect" class="el-menu-demo wrap" mode="horizontal" background-color="#054C81" text-color="#ffffff" active-text-color="#fff">
      <!-- 			<el-menu-item index="index">首页</el-menu-item>
			<el-menu-item index="news">公司新闻</el-menu-item>
			<el-menu-item index="bidding">招标专区</el-menu-item>
			<el-menu-item index="unbidding">非招标专区</el-menu-item>
			<el-menu-item index="supplier">供应商招募</el-menu-item>
			<el-menu-item index="policyregular">政策法规</el-menu-item>
			<el-menu-item index="server">服务专区</el-menu-item> -->
      <el-menu-item :index="menu.link" v-for="(menu, index) in menuList" :key="index">{{ menu.name }}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 'index',
      menuList: []
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: 'changeIndex'
  },
  mounted() {
    this.getRequest('/Information/GetMenu')
      .then((res) => {
        var data = res.data
        if (data.errcode == 0) {
          this.menuList = data.menuList
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    this.$nextTick(() => {
      this.changeIndex()
    })
  },
  methods: {
    changeIndex() {
      this.activeIndex = sessionStorage.getItem('IndexTab')
    },
    handleSelect(key) {
      this.$router.push({ name: key })
      sessionStorage.setItem('IndexTab', key)
    }
  }
}
</script>
<style scoped lang="scss">
.title_bar {
  background-color: #054c81;
}
.title_bar ::v-deep .el-menu {
  border-bottom: none;
  .el-menu-item {
    font-size: 16px;
    padding: 0 40px;
    height: 50px;
    line-height: 50px;
  }
}
.title_bar ::v-deep .el-menu-item.is-active {
  background-color: #0774c5 !important;
  border-bottom: none !important;
}
</style>
